/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

export const validationSchema = Yup.object({
  enabled: Yup.boolean(),
  issuerUrl: Yup.string()
    .required('empty')
    .test({
      name: 'is-valid-url',
      message: 'invalid_url',
      test: val => {
        if (!val) return true;

        return URL.canParse(val);
      },
    }),
  clientId: Yup.string().required('empty'),
  clientSecret: Yup.string().required('empty'),
  groupAttribute: Yup.string(),
  verifyCertificate: Yup.boolean(),
  domains: Yup.array()
    .of(
      Yup.string()
        .required('empty')
        .test({
          name: 'is-valid-domain',
          message: 'invalid_domain',
          test: val => {
            if (!val) return true;

            return /^(?!-)[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/.test(val);
          },
        }),
    )
    .min(1, 'empty')
    .test('is-unique-domains', 'unique_arr', val => new Set(val).size === val.length),
});
